// https://fordprofile.cms.dealer.com/MustangMachE.htm
export default {
	events: {
		'ddc.link.generic': [
			{
				// Locale for this pageType only gives english for CTA
				logic: ({ eventData }) => eventData.text.includes('Learn More'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick:
								'referral:fv:vehicle:home:ford mustang mach-e',
							referredTo: 'fv:vehicle:home:ford mustang mach-e',
							onclickLinkName: 'referral:exit'
						},
						event: {
							action: 'brand referral'
						}
					}
				}
			},
			{
				logic: ({ eventData }) =>
					eventData.attributes.class.includes('view-inventory'),
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'ev vhp:content:view inventory',
							onclickLinkName: '{client}ev vhp:content:action'
						}
					}
				}
			},
			{
				logic: ({ eventData }) =>
					eventData.attributes.class.includes(
						'search-mache-inventory'
					),
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'ev vhp:content:search inventory',
							onclickLinkName: '{client}ev vhp:content:action'
						}
					}
				}
			},
			{
				logic: ({ eventData }) => {
					const ctaClassNames = [
						'see-how-much-you-could-save',
						'explore-public-charging',
						'explore-home-charging',
						'explore-technology'
					];
					const ctaClassName = ctaClassNames.find((className) =>
						eventData.attributes.class.includes(className)
					);

					return ctaClassName;
				},
				payload: ({ eventData }) => {
					const ctaClassNames = [
						'see-how-much-you-could-save',
						'explore-public-charging',
						'explore-home-charging',
						'explore-technology'
					];

					const ctaType = ctaClassNames.find((className) =>
						eventData.attributes.class.includes(className)
					);
					const ctaTypeMap = {
						'see-how-much-you-could-save':
							'see how much you can save',
						'explore-public-charging': 'public ev charging',
						'explore-home-charging': 'home charging',
						'explore-technology': 'explore technology'
					};

					return {
						directCall: 'referral-exit',
						payload: {
							event: {
								action: 'brand referral'
							},
							onclick: {
								onclick: `referral:${ctaTypeMap[ctaType]}`,
								onclickLinkName: 'referral:exit',
								referredTo: ctaTypeMap[ctaType]
							}
						}
					};
				}
			}
		]
	}
};
